import { defineStyle, defineStyleConfig } from "@chakra-ui/react";

const layout = defineStyle({
    maxW: "1200px",
    w:"100%",
    px: "15px",
});

const header = defineStyle({
    w: "100%",
    maxW:"100%",
    m: "20px 0 0 0",
    p:"19px",
    bgColor: "primary.bgGrey",
    border:"1px solid",
    borderColor:"primary.borderGrey",
    borderRadius:"4px",
    boxShadow:"inset 0 1px 1px rgba(0,0,0,.05)"
});

const main = defineStyle({
    maxW: "100%",
    h: "calc(100% - 120px)",
    padding: "0",
});

const footer = defineStyle({
});

const containerTheme = defineStyleConfig({
    variants: { layout, header, main, footer },
});

export default containerTheme;
